import { useChainId } from 'wagmi';
import { CHAIN_TO_KEY, DEFAULT_KEY, type NetworkKey } from '../config/networks.generated';

// The active bridge network is derived from the wallet's current chainId. The
// chainId→key map and default are generated per environment from the exposed
// networks (see networks.generated.ts / REACT_APP_BRIDGE_ENV).
export function networkKeyFromChainId(chainId: number | undefined): NetworkKey {
  if (chainId == null) return DEFAULT_KEY;
  return CHAIN_TO_KEY[chainId] ?? DEFAULT_KEY;
}

export function useBridgeNetworkKey(): NetworkKey {
  const chainId = useChainId();
  return networkKeyFromChainId(chainId);
}
